import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import useVerify from "../api/useVerify";
import useRouterData from "@/hooks/api/useRouterData";
import FullScreenLoader from "@/components/feedback/full-screen-loader/FullScreenLoader";
import { useAppSelector } from "@/stores/hook";
import { RedirectToLogin } from "./loginReturn";
import { useIdentityRouteGuard } from "@/routes/useIdentityRouteGuard";
import { registerGlobalNavigate } from "@/routes/globalNavigate";

export default function ProtectedRoute() {
  // Redux first so the flag is REACTIVE — a bare localStorage read during
  // render doesn't re-run when login/logout swaps the token.
  const storeToken = useAppSelector((state) => state.auth.token);
  const hasToken =
    !!storeToken ||
    (typeof window !== "undefined" &&
      !!localStorage.getItem("xale_access_token"));

  useVerify({ isFetch: hasToken });
  const { isLoading } = useRouterData();

  // Wraps every authenticated route (including the catch-all), so this is the
  // one place that sees a tenant/user switch no matter which URL it happens on.
  useIdentityRouteGuard();

  // Expose the router's navigate to code above the router (socket toast
  // clicks) — see routes/globalNavigate.ts.
  const navigate = useNavigate();
  useEffect(() => {
    registerGlobalNavigate(navigate);
  }, [navigate]);

  if (!hasToken) return <RedirectToLogin />;
  if (isLoading) return <FullScreenLoader />;

  return <Outlet />;
}
